import { Box } from 'braid-design-system';

import * as styles from './styles.css';

interface Props {
  label: string;
}

const MandatoryLabel = ({ label }: Props) => (
  <>
    {label}
    <Box className={styles.criticalColor} component="span">
      *
    </Box>
  </>
);

export const mandatoryLabel = (label: string) => ({
  'aria-label': `${label} (required)`,
  label: <MandatoryLabel label={label} />,
});
